import { pageNumberState } from "@/atoms/order/page-number-state";
import { DEBOUNCE_TIME } from "@/common/constant/debounce-time";
import { PaginationSize } from "@/common/enum/pagination-size";
import { PartnerNotificationHeader } from "@/components/header/PartnerNotificationHeader";
import { PartnerNoticeDetailPanel } from "@/components/panel/PartnerNoticeDetailPanel";
import { PartnerNoticeTable } from "@/components/table/partner-notice/PartnerNoticeTable";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { noticeService } from "@/services/notice-service";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { initNoticePage, NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { NoticePagePayload } from "@/types/payload/notice-page-payload";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";

export default function PartnerNoticePage() {
  const [noticePage, setNoticePage] =
    useState<BasePageDto<NoticeDetailDto>>(initNoticePage);
  const [selectedNotice, setSelectedNotice] = useState<
    NoticeDetailDto | undefined
  >();
  const location = useLocation();
  const { id } = location.state || {};

  const handlePageChange = (currentPage: number) => {
    setNoticePage({ ...noticePage, currentPage });
  };

  const handleNoticeRowClick = async (id: number) => {
    try {
      const findNotice = noticePage.contents.find((notice) => notice.id === id);
      if (!findNotice) {
        return;
      }
      setSelectedNotice(findNotice);
    } catch (error) {
      console.log(error);
    }
  };

  const getPage = async (input: NoticePagePayload) => {
    try {
      const response = await noticeService.getPage(input);

      if (response.ok) {
        let updatedContents = [...response.data.contents];
        let selectedNotice =
          updatedContents.length > 0 ? updatedContents[0] : undefined;
        if (id) {
          const responseById = await noticeService.getById({ id });
          if (responseById.ok) {
            const existingItem = updatedContents.find(
              (item) => item.id === responseById.data.id
            );
            if (!existingItem) {
              updatedContents = [responseById.data, ...updatedContents];
            }
            selectedNotice = responseById.data;
          }
        }
        setNoticePage({
          ...response.data,
          contents: updatedContents,
        });
        setSelectedNotice(selectedNotice);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [pageNumber, setPageNumber] = useRecoilState(pageNumberState);

  const getPageDebounce = useCallback(
    debounce(async (input) => {
      await getPage(input);
    }, DEBOUNCE_TIME),
    []
  );

  useEffect(() => {
    const payload = {
      page: pageNumber,
      size: PaginationSize.SIZE_12,
    };
    getPageDebounce(payload);
  }, [pageNumber]);

  useEffect(() => {
    const payload = {
      page: 1,
      size: PaginationSize.SIZE_12,
    };
    setPageNumber(1);
    getPageDebounce(payload);
  }, [id]);

  useEffect(() => {
    return () => {
      setPageNumber(1);
    };
  }, []);

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1392px] items-center">
        <PartnerNotificationHeader />
        <div className="flex">
          <PartnerNoticeTable
            page={noticePage}
            selectedNotice={selectedNotice}
            handleNoticeNameClick={handleNoticeRowClick}
            handlePageChange={handlePageChange}
          />
          {selectedNotice && (
            <PartnerNoticeDetailPanel selectedNotice={selectedNotice} />
          )}
        </div>
      </div>
    </PageWrapper>
  );
}
